<template>
    <div class="leftItem">
        <div v-bind:class="itemName=='home'?'nav active':'nav'" @click="goHome()">
            <i class="iconfont icon-1" style="font-size:28px"></i>
            <span>首页</span>
        </div>
        <div
            v-bind:class="itemName==item.value?'nav active':'nav'"
            v-for="item in menuList"
            :key="item.value"
            @click="go(item)"
            v-if="$_has(item.value) && item.show"
        >
            <i v-bind:class="'iconfont '+ item.icon" v-bind:style="item.size"></i>
            <span>{{item.title}}</span>
        </div>
    </div>
</template>
<script>
import menu from "@/config/menu";

export default {
    name: "leftItem",
    watch: {
        //监听路由变化
        $route(newRoute) {
            if (newRoute.meta.parent) {
                this.itemName = newRoute.name;
            } else {
                this.itemName = newRoute.meta.parentName;
            }
        }
    },
    created() {
        this.itemName = this.$route.name;
        if (this.$route.meta.parent) {
            this.itemName = this.$route.name;
        } else {
            this.itemName = this.$route.meta.parentName;
        }
    },
    data() {
        return {
            itemName: "home",
            menuList: menu.menu
        };
    },
    methods: {
        go(item) {
            if (this.itemName != item.value) {
                this.$router.push({ name: item.value });
            }
        },
        goHome() {
            if (this.itemName != "home") {
                this.$router.push({ name: "home" });
            }
        }
    }
};
</script>

<style lang="less">
.leftItem {
    height: calc(100% - 54px);
    width: 90px;
    float: left;
    // background: linear-gradient(#2c54ce, #3791e8);
    overflow: hidden;
    overflow-y: auto;
    .nav {
        width: calc(100% - 10px);
        text-align: center;
        font-size: 24px;
        color: #a9a9a9;
        padding: 10px 0;
        cursor: pointer;
        float: left;
        background: #fff;
        span {
            display: block;
            width: 100%;
            font-size: 14px;
            padding: 0;
            float: left;
            margin-top: 5px;
        }
        margin: 2px 5px;
        border-radius: 5px;
        box-shadow: 1px 2px 3px #ccc;
    }
    .nav:last-child {
        border-bottom: none;
    }
    .nav.active {
        background: #fff;
        color: #2c54ce;
    }
}

.leftItem::-webkit-scrollbar {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/leftItem.vue